import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/auth/AuthContext";
import { PortalConfigProvider } from "@/portal/PortalConfigContext";
import { router } from "@/router";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const maybeAxios = error as { response?: { status?: number } };
        const status = maybeAxios.response?.status;
        if (status !== undefined && status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
    },
  },
});

export function App(): React.ReactElement {
  return (
    <QueryClientProvider client={queryClient}>
      {/* AuthProvider СНАРУЖИ: его восстановление сессии и загрузка
          конфигурации инсталляции независимы, и при обратной вложенности
          `/api/auth/refresh` не стартовал бы, пока не ответит `/api/config` —
          холодный старт на ТСД стоил бы двух RTT вместо одного.
          Гейт остаётся: роутер рисуется только с конфигурацией на руках. */}
      <AuthProvider>
        <PortalConfigProvider>
          <RouterProvider router={router} />
          <Toaster position="top-right" richColors />
        </PortalConfigProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
